import {axiosSybox} from "@/utils/axios";
import {objectToFormData} from "@/utils/ObjectToFormData";

const BASE_URL = '/constructor'

export default {
    namespaced: true,

    state() {
        return {
            currentFormView: '',
            fullFormStages: [],
            shortFormStages: [],
            fullForm: {
                'PRODUCT_QUANTITY': 1,
                'USER_COMMENT': ''
            },
            shortForm: {
                'PRODUCT_QUANTITY': 1,
                'USER_COMMENT': ''
            },
        }
    },
    mutations: {
        setCurrentFormView(state, viewString) {
            if (typeof viewString !== 'string') return;
            state.currentFormView = viewString;
        },
        setFormKey(state, {key, type, value}) {
            if (!state.currentFormView) return;
            if (type === 'checkbox') {
                if (state[state.currentFormView][key]?.includes(value) ) {
                    state[state.currentFormView][key] = state[state.currentFormView][key].filter((item) => item !== value);
                } else {
                    state[state.currentFormView][key].push(value);
                }
            } else {
                state[state.currentFormView][key] = value;
            }
        },
        setStages(state, {view, data}) {
            if (!Array.isArray(data) || !['fullForm', 'shortForm'].includes(view)) return;
            state[`${view}Stages`] = data;
            data.forEach((stage) => {
                stage.groups?.forEach((group) => {
                    group.fields?.forEach((field) => {
                        if (field.type === 'checkbox') {
                            state[view][field.code] = [];
                        } else if (field.type === 'file') {
                            state[view][field.code] = null;
                        } else {
                            state[view][field.code] = '';
                        }
                    })
                })
            })
        },
        clearForm(state, {formView}) {
            if (!['fullForm', 'shortForm'].includes(formView)) return;

            state[`${formView}Stages`]?.forEach((stage) => {
                stage.groups?.forEach((group) => {
                    group.fields?.forEach((field) => {
                        if (field.type === 'checkbox') {
                            state[formView][field.code] = [];
                        } else if (field.type === 'file') {
                            state[formView][field.code] = null;
                        } else {
                            state[formView][field.code] = '';
                        }
                    })
                })
            })
        }
    },
    actions: {
        sendIndividualPacking({commit, dispatch, state}) {
            commit('startLoading', 'sendIndividualPacking', { root: true })

            const body = objectToFormData({
                ...state[state.currentFormView],
                'FORM_TYPE': state.currentFormView,
            });

            return new Promise((resolve, reject) => {
                axiosSybox.post(`${BASE_URL}/addToCart/`, body)
                    .then(({data: response}) => {
                        resolve(response.data);
                        dispatch('moduleCart/load', null, {root: true});
                        commit('clearForm', {formView: state.currentFormView});
                    })
                    .catch((e) => {
                        dispatch('showError', { error: e }, {root: true}).then((message) => reject(message));
                    })
                    .finally(() => {
                        commit('stopLoading', 'sendIndividualPacking', { root: true })
                    })
            })
        },
        requestFormStages({state, dispatch}) {
            if (state.currentFormView === 'shortForm') {
                return dispatch('requestShortFormStages');
            } else if (state.currentFormView === 'fullForm') {
                return dispatch('requestFullFormStages');
            }
        },
        requestFullFormStages({commit, dispatch}) {
            commit('startLoading', 'requestFullFormStages', { root: true })
            return new Promise((resolve, reject) => {
                axiosSybox.get(`${BASE_URL}/stages/`)
                    .then(({data: response}) => {
                        commit('setStages', {view: 'fullForm', data: response.data});
                        resolve(response.data);
                    })
                    .catch((e) => {
                        dispatch('showError', { error: e }, {root: true}).then((message) => reject(message));
                    })
                    .finally(() => {
                        commit('stopLoading', 'requestFullFormStages', { root: true })
                    })
            })
        },
        requestShortFormStages({commit, dispatch}) {
            commit('startLoading', 'requestShortFormStages', { root: true })
            return new Promise((resolve, reject) => {
                axiosSybox.get(`${BASE_URL}/stages-finished/`)
                    .then(({data: response}) => {
                        commit('setStages', {view: 'shortForm', data: response.data});
                        resolve(response.data);
                    })
                    .catch((e) => {
                        dispatch('showError', { error: e }, {root: true}).then((message) => reject(message));
                    })
                    .finally(() => {
                        commit('stopLoading', 'requestShortFormStages', { root: true })
                    })
            })
        }
    },
    getters: {
        getCurrentFormView: (state) => state.currentFormView,
        getFormStages: (state) => {
            if (state.currentFormView === 'shortForm') {
                return state.shortFormStages;
            } else if (state.currentFormView === 'fullForm') {
                return state.fullFormStages;
            }

            return [];
        },
        getFormValueByKey: (state) => (key) => {
            if (state.currentFormView === 'shortForm') {
                return state.shortForm[key];
            } else if (state.currentFormView === 'fullForm') {
                return state.fullForm[key];
            }

            return null;
        },
        getForm: (state) => {
            if (state.currentFormView === 'shortForm') {
                return state.shortForm;
            } else if (state.currentFormView === 'fullForm') {
                return state.fullForm;
            }

            return {};
        },
    }
}